import React, { useState, useEffect, ReactNode } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

interface PageWrapperProps {
    children: ReactNode;
}
const PageWrapper = ({ children }: PageWrapperProps) => {
    const navigate = useNavigate();
    const [inactive, setInactive] = useState(false);
    const { buildingId } = useParams<{ buildingId: string }>();

    useEffect(() => {
        let inactivityTimer: ReturnType<typeof setTimeout>;

        const resetTimer = () => {
            clearTimeout(inactivityTimer);
            inactivityTimer = setTimeout(() => {
                setInactive(true);
            }, 120000); // 120 second in milliseconds
        };

        const handleUserActivity = () => {
            setInactive(false);
            resetTimer();
        };

        window.addEventListener('mousemove', handleUserActivity);
        window.addEventListener('mousedown', handleUserActivity);
        window.addEventListener('keypress', handleUserActivity);
        window.addEventListener('touchmove', handleUserActivity);
        window.addEventListener('scroll', handleUserActivity);

        resetTimer();

        return () => {
            window.removeEventListener('mousemove', handleUserActivity);
            window.removeEventListener('mousedown', handleUserActivity);
            window.removeEventListener('keypress', handleUserActivity);
            window.removeEventListener('touchmove', handleUserActivity);
            window.removeEventListener('scroll', handleUserActivity);
            clearTimeout(inactivityTimer);
        };
    }, []);

    useEffect(() => {
        if (inactive) {
            window.location.href = `/${buildingId}`;
        }
    }, [inactive, navigate]);

    return <>{children}</>;
};

export default PageWrapper;
